import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getClasses = createAsyncThunk(
  "student/allClasses",
  async ({ page, limit, searchData }, { rejectWithValue }) => { 
    try {
      let url = `/classes/all?page=${page}&limit=${limit}`;
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response;  
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



const initialState = {
  classesData: [],
  };
  
  const classesSlice = createSlice({
    name: "classesSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
      builder.addCase(getClasses.fulfilled, (state, action) => {
        state.classesData = action.payload.data;
      });
    },
  });
  export default classesSlice.reducer;
